/**
 * Translates a password-policy rule label into pt-BR.
 *
 * The Auth0 ACUL SDK (`usePasswordValidation`) returns the rule labels in
 * English (e.g. "At least 8 characters"). We map them by the stable `code`,
 * which is locale-independent. The numeric argument (minimum length, "at least
 * N of", max identical run) comes from `rule.args.count` when the SDK provides
 * it, falling back to the first number found in the English label.
 *
 * Unknown codes fall back to the original SDK label so nothing renders blank.
 */
type TranslatableRule = {
  code: string;
  label: string;
  args?: { count?: number };
};

export function translatePasswordRuleLabel(rule: TranslatableRule): string {
  const labelMatch = rule.label.match(/\d+/);
  const count =
    rule.args?.count ?? (labelMatch ? Number(labelMatch[0]) : undefined);

  switch (rule.code) {
    case "password-policy-length-at-least":
      return `Pelo menos ${count ?? 8} caracteres`;
    case "password-policy-contains-at-least":
      return `Pelo menos ${count ?? 3} dos seguintes:`;
    case "password-policy-lower-case":
      return "Letras minúsculas (a-z)";
    case "password-policy-upper-case":
      return "Letras maiúsculas (A-Z)";
    case "password-policy-numbers":
      return "Números (0-9)";
    case "password-policy-special-characters":
      return "Caracteres especiais (ex.: !@#$%^&*)";
    case "password-policy-identical-chars":
      return `No máximo ${count ?? 2} caracteres idênticos seguidos`;
    default:
      return rule.label;
  }
}
